"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomeEligibleTiersWarningModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var reactstrap_1 = require("reactstrap");
var services_1 = require("@falcon/services");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../../../commonFunctions");
var AnnualHomeEligibleTiersWarningModal = /** @class */ (function (_super) {
    __extends(AnnualHomeEligibleTiersWarningModal, _super);
    function AnnualHomeEligibleTiersWarningModal(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isTierWarningModalOpen: false,
            tieredUnderwritingResult: _this.props.interaction.tieredUnderwritingResult
        };
        _this.toggle = _this.toggle.bind(_this);
        _this.updateModalVisibility = _this.updateModalVisibility.bind(_this);
        return _this;
    }
    AnnualHomeEligibleTiersWarningModal.prototype.render = function () {
        var closeBtn = (0, jsx_runtime_1.jsx)("button", { className: "btn-close", onClick: this.toggle });
        var tierWarningWordingElement = this.getTierWarningWordingAsElement();
        var isTierWarningWordingElementPopulated = React.Children.count(tierWarningWordingElement.props.children) > 0;
        if (isTierWarningWordingElementPopulated && !this.state.isTierWarningModalOpen) {
            this.updateModalVisibility();
        }
        if (isTierWarningWordingElementPopulated && this.state.isTierWarningModalOpen) {
            return ((0, jsx_runtime_1.jsxs)(reactstrap_1.Modal, { className: "my-2 info-modal", isOpen: this.state.isTierWarningModalOpen, toggle: this.toggle, children: [(0, jsx_runtime_1.jsx)(reactstrap_1.ModalHeader, { toggle: this.toggle, close: closeBtn, children: (0, jsx_runtime_1.jsxs)("div", { className: "d-flex", children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("img", { className: "mr-2 info-icon-selected", src: "/img/Flow-info-selected.svg", alt: "Info icon selected" }) }), (0, jsx_runtime_1.jsx)("div", { className: "text-blue-2 font-weight-medium", children: "Because of the changes you've made..." })] }) }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalBody, { className: "pt-0", children: tierWarningWordingElement }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalFooter, { className: "d-flex", children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-primary btn-add width-md-250 mb-1", onClick: this.toggle, children: "Ok, I understand" }) })] }));
        }
        else {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
    };
    AnnualHomeEligibleTiersWarningModal.prototype.getTierWarningWordingAsElement = function () {
        var tierLabels = new Map();
        tierLabels.set(services_1.BRONZE_TIER, { full: "Allianz Online Bronze", short: "Bronze" });
        tierLabels.set(services_1.SILVER_TIER, { full: "Allianz Online Silver", short: "Silver" });
        tierLabels.set(services_1.GOLD_TIER, { full: "Allianz Online Gold", short: "Gold" });
        var initialUwResult = this.state.tieredUnderwritingResult;
        var newUwResult = this.props.interaction.tieredUnderwritingResult;
        var renderBronzeTier = (0, commonFunctions_1.isTierNotDeclined)(services_1.BRONZE_TIER, newUwResult);
        var renderSilverTier = (0, commonFunctions_1.isTierNotDeclined)(services_1.SILVER_TIER, newUwResult);
        var renderGoldTier = (0, commonFunctions_1.isTierNotDeclined)(services_1.GOLD_TIER, newUwResult);
        var renderTiers = [
            renderBronzeTier && services_1.BRONZE_TIER,
            renderSilverTier && services_1.SILVER_TIER,
            renderGoldTier && services_1.GOLD_TIER,
        ].filter(Boolean);
        var bronzeChanged = this.tierResultChanged(services_1.BRONZE_TIER, initialUwResult, newUwResult);
        var silverChanged = this.tierResultChanged(services_1.SILVER_TIER, initialUwResult, newUwResult);
        var goldChanged = this.tierResultChanged(services_1.GOLD_TIER, initialUwResult, newUwResult);
        if ((bronzeChanged || silverChanged || goldChanged) && renderTiers.length > 0) {
            return (0, jsx_runtime_1.jsxs)("span", { children: ["...you're now only eligible for our", " ", this.renderTierList(renderTiers, tierLabels), " policy."] });
        }
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    };
    AnnualHomeEligibleTiersWarningModal.prototype.renderTierList = function (tiers, tierLabels) {
        if (tiers.length === 1) {
            return (0, jsx_runtime_1.jsx)("strong", { children: tierLabels.get(tiers[0]).full });
        }
        var labels = tiers.map(function (tier, index) {
            return index === 0 ? tierLabels.get(tier).full : tierLabels.get(tier).short;
        });
        var boldLabels = labels.map(function (label, i) { return ((0, jsx_runtime_1.jsx)("strong", { children: label }, "".concat(label, "-").concat(i))); });
        if (boldLabels.length === 2) {
            return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [boldLabels[0], " or ", boldLabels[1]] });
        }
        return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [boldLabels[0], ", ", boldLabels[1], " or ", boldLabels[2]] });
    };
    AnnualHomeEligibleTiersWarningModal.prototype.toggle = function () {
        this.setState({
            isTierWarningModalOpen: !this.state.isTierWarningModalOpen,
            tieredUnderwritingResult: this.props.interaction.tieredUnderwritingResult
        });
    };
    AnnualHomeEligibleTiersWarningModal.prototype.updateModalVisibility = function () {
        this.setState({
            isTierWarningModalOpen: !this.state.isTierWarningModalOpen
        });
    };
    AnnualHomeEligibleTiersWarningModal.prototype.tierResultChanged = function (tier, oldUwResult, newUwResult) {
        var previouslyDeclined = oldUwResult.filter(function (uw) { return uw.tier === tier; })[0].underwritingFailures.length > 0;
        var declinedNow = newUwResult.filter(function (uw) { return uw.tier === tier; })[0].underwritingFailures.length > 0;
        return previouslyDeclined !== declinedNow;
    };
    return AnnualHomeEligibleTiersWarningModal;
}(plugin_journey_1.WidgetBase));
exports.AnnualHomeEligibleTiersWarningModal = AnnualHomeEligibleTiersWarningModal;
//# sourceMappingURL=AnnualHomeEligibleTiersWarningModal.js.map